// extracted by mini-css-extract-plugin
export default {"base":"vp_qEBKW","copy":"vp_s8Sz1","title":"vp_cBf4h","text":"vp_YO2L5","actions":"vp_Y_A3T"};